// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/inventory/non-medical-master/-components/component";
import { SearchParams } from "@/routes/(pharma)/_layout/inventory/non-medical-master/-data/model";
import { getNonMedicalMasterItems } from "@/routes/(pharma)/_layout/inventory/non-medical-master/-data/api";
import { NonMedicalMasterSchema } from "@/routes/(pharma)/_layout/inventory/non-medical-master/-data/type";
import { Loading } from "@/layouts/loading";
import { ListNonMedicalMasterResponse } from "@/gen/non_medical_master/list_non_medical_master_pb";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(pharma)/_layout/inventory/non-medical-master/")({
    component: Component,
    validateSearch: SearchParams,
});